var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFill = function SvgHeartFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.754 12.505 11.507 19 5.26 12.505a4.4 4.4 0 0 1-.953-1.486 4.57 4.57 0 0 1 .088-3.505A4.4 4.4 0 0 1 5.42 6.082a4.1 4.1 0 0 1 1.487-.878 3.98 3.98 0 0 1 3.322.372c.5.299.934.704 1.277 1.188.344-.48.78-.882 1.279-1.178a3.977 3.977 0 0 1 3.313-.36c.546.182 1.05.48 1.481.877s.78.882 1.024 1.427a4.564 4.564 0 0 1 .095 3.495 4.4 4.4 0 0 1-.945 1.485"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.754 12.505 11.507 19 5.26 12.505a4.4 4.4 0 0 1-.953-1.486 4.57 4.57 0 0 1 .088-3.505A4.4 4.4 0 0 1 5.42 6.082a4.1 4.1 0 0 1 1.487-.878 3.98 3.98 0 0 1 3.322.372c.5.299.934.704 1.277 1.188.344-.48.78-.882 1.279-1.178a3.977 3.977 0 0 1 3.313-.36c.546.182 1.05.48 1.481.877s.78.882 1.024 1.427a4.564 4.564 0 0 1 .095 3.495 4.4 4.4 0 0 1-.945 1.485"
  })));
};
export default SvgHeartFill;